module.exports = __webpack_public_path__ + "assets/img/de1bc79e02dc48396cb53aa15c4e68af.svg";